// Makes a basic AJAX request with the given options
export const makeRequest = function (options: object) {
  let defaultOptions = {
    contentType: 'application/json',
    method: 'post',
    onTimeout: function () { },
    onError: function (status: any, metadata: any) { },
    onLoad: function (status: any, responseBody: any) { },
    parameters: {},
    url: '',
  };
  let requestOptions = Object.assign({}, defaultOptions, options);
  let request = new XMLHttpRequest();
  request.open(requestOptions.method, requestOptions.url);
  request.setRequestHeader('Content-Type', requestOptions.contentType);
  request.send(JSON.stringify(requestOptions.parameters));
  request.onreadystatechange = function (event) {
    // void event;
    if (request.readyState === XMLHttpRequest.DONE) {
      let responseBody;
      try {
        responseBody = JSON.parse(request.responseText);
      } catch (err) {
        responseBody = {};
      }
      let status = request.status;
      if (status < 500) {
        requestOptions.onLoad(status, responseBody);
      } else {
        requestOptions.onError(status, {});
      }
    }
  };
  return request;
};

export function asyncify<T>(func: Function): (...args) => Promise<T> {
  return async (...args) => {
    return new Promise<T>((resolve, reject) => {
      const callback = (err, data) => err ? reject(err) : resolve(data);

      // @ts-ignore
      func.apply(this, [...args, callback]);
    });
  };
}
